import React from "react";
import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from "react-router";

import LayoutUser from "app/components/LayoutUser";

import "./styles.scss";
import { getAlbums, putAlbums, putResource, deleteAlbum, deleteResource } from 'app/api/redux/Gallery/actions';
import { Album, Resource } from 'app/api/types';
import AlbumsList from '../../components/AlbumsList';

interface IProps extends RouteComponentProps {
    albums: Album[];
    progress: number;
    isLoading: boolean;
    getAlbums: () => Album[];
    putAlbums: (album: Album) => void;
    putResource: (payload: { albumId: string, resource: Resource, file?: File, preview?: File }) => Promise<void>;
    deleteAlbum: (id: string) => void;
    deleteResource: (payload: { id: string, albumId: string }) => Promise<void>;
}

class GalleryPage extends React.Component<IProps> {
    componentDidMount() {
        this.props.getAlbums();
    }

    putResource = (payload: { albumId: string, resource: Resource, file?: File, preview?: File }) => {
        this.props.putResource(payload).then(()=> this.props.getAlbums());
    }

    deleteResource = (payload: { id: string, albumId: string }) => {
        this.props.deleteResource(payload).then(()=> this.props.getAlbums());
    }

    render() {
        return (
            <LayoutUser>
                <AlbumsList
                    isLoading={this.props.isLoading}
                    albums={this.props.albums}
                    progress={this.props.progress}
                    getAlbums={this.props.getAlbums}
                    putAlbums={this.props.putAlbums}
                    putResource={this.putResource}
                    deleteAlbum={this.props.deleteAlbum}
                    deleteResource={this.deleteResource}
                />
            </LayoutUser>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        isLoading: false,
        albums: state.gallery.albums,
        progress: state.gallery.progress,
    };
};

export default withRouter(
    connect(mapStateToProps, { getAlbums, putAlbums, putResource, deleteAlbum, deleteResource })(GalleryPage)
);
